import { convertToWebP } from './convert-to-webp'
import { imageApi } from './api'

/**
 * Converts a File to WebP and uploads it to the server.
 * Returns the CDN URL of the uploaded image.
 */
export async function uploadImageFile(file: File): Promise<string> {
  const webpBlob = await convertToWebP(file)
  const { url } = await imageApi.uploadImage(webpBlob)
  return url
}

/**
 * Inserts `![](url)` at the current cursor position in a textarea.
 * Adds surrounding newlines if needed so the image is on its own line.
 *
 * @param textarea  The HTMLTextAreaElement to insert into
 * @param url       The image URL to embed
 * @param setValue  React state setter for the textarea value
 * @param savedPos  Optional cursor position saved before an async operation
 */
export function insertImageAtCursor(
  textarea: HTMLTextAreaElement,
  url: string,
  setValue: (v: string) => void,
  savedPos?: number,
): void {
  const pos = savedPos ?? textarea.selectionStart ?? textarea.value.length
  const endPos = savedPos != null ? pos : (textarea.selectionEnd ?? pos)
  const before = textarea.value.slice(0, pos)
  const after = textarea.value.slice(endPos)

  const needLeading = before.length > 0 && !before.endsWith('\n')
  const needTrailing = after.length > 0 && !after.startsWith('\n')
  const insertion = (needLeading ? '\n' : '') + `![](${url})` + (needTrailing ? '\n' : '')

  setValue(before + insertion + after)

  const newCursor = before.length + insertion.length
  requestAnimationFrame(() => {
    textarea.setSelectionRange(newCursor, newCursor)
    textarea.focus()
  })
}
